// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wells-table[data-v-20d46f55] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
